import React, { useEffect, useState } from "react"
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Grid,
    Autocomplete,
    Typography
} from "@mui/material"
import { Controller, useForm } from "react-hook-form"
import apiUrl from '../../configs/constant';
import axios from 'axios'
import { useToast } from "../ToastProvider";

const today = () => new Date().toISOString().split("T")[0]

interface Props {
    open: boolean
    mode: string
    data?: any
    onClose: () => void
}

export default function DialogMemoApAdd({
    open,
    mode,
    data,
    onClose
}: Props) {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();
    const [akunList, setAkunList] = useState<any[]>([])
    const [supplierList, setSupplierList] = useState<any[]>([])
    const [invoiceReceiptList, setInvoiceReceiptList] = useState<any[]>([])

    useEffect(() => {
        if (!open) return
        setValue('tanggal', today())
        getAkun()
        getSupplier()
        console.log(data)
    }, [open])

    const {
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        getValues,
        reset,
        watch
    } = useForm({
        defaultValues: {
            tanggal: today(),
            totalInvoice: '',
            sisaHutang: '',
            akun: null,
            totalSesuaian: '',
            hutangAkhir: '',
            keterangan: '',
            accir_id: null,
            supplier_id: null
        }
    })

    const sisaHutang = watch("sisaHutang")
    const totalSesuaian = watch("totalSesuaian")

    useEffect(() => {
        const sisa = Number(sisaHutang || 0)
        const sesuaian = Number(totalSesuaian || 0)
        const hasil = sisa - sesuaian
        setValue("hutangAkhir", formatNumber(hasil))
    }, [sisaHutang, totalSesuaian, setValue])

    const getAkun = () => {
        let url = apiUrl.apiUrl + '/acc/laporan-keuangan/list-akun-biaya'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setAkunList(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }
    const getSupplier = () => {
        const url = apiUrl.apiUrl + '/acc/invoice-receipt/get-supplier'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setSupplierList(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getInvoiceReceipt = (ids: any) => {

        let url = apiUrl.apiUrl + '/acc/memo-ap/list-ir-by-supplier'

        axios
            .get(url, {
                params: { supplier_id: ids },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    setInvoiceReceiptList(response.data.data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const onSubmit = (obj: any) => {
        const payload = {
            tgl: obj.tanggal,
            supplier_id: obj.supplier_id.id,
            accir_id: obj.accir_id.id,
            total_invoice: String(obj.totalInvoice || "").replace(/\./g, ""),
            sisa_hutang: String(obj.sisaHutang || "").replace(/\./g, ""),
            total_sesuaian: String(obj.totalSesuaian || "").replace(/\./g, ""),
            hutang_akhir: String(obj.hutangAkhir || "").replace(/\./g, ""),
            accakun_id: obj.akun?.id,
            sysdoctag_id: 12603000005,
            keterangan: obj.keterangan
        }

        const url = apiUrl.apiUrl + '/acc/memo-ap/save'

        axios.post(url, payload, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(res => {
            showToast(res.data.message, 'success')
            onClose()
        })
    }

    const formatNumber = (value: string | number) => {
        if (!value) return ""
        return Number(value).toLocaleString("id-ID")
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>
                    {mode === "add" ? "Tambah Memo AP" : "Edit Memo AP"}
                </DialogTitle>

                <DialogContent dividers>

                    <Grid container spacing={2}>

                        {/* INFORMASI DASAR */}
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                Informasi Dasar
                            </Typography>
                        </Grid>
                        {/* Supplier */}
                        <Grid item xs={12}>
                            <Controller
                                name="supplier_id"
                                control={control}
                                rules={{ required: "Supplier wajib dipilih" }}
                                render={({ field }) => (
                                    <Autocomplete
                                        {...field}
                                        value={field.value || null}
                                        options={supplierList}
                                        isOptionEqualToValue={(opt, val) => opt.id === val?.id}
                                        getOptionLabel={(o) => o?.nama ?? ""}
                                        onChange={(_, val) => {
                                            field.onChange(val)
                                            getInvoiceReceipt(val?.id) // panggil function
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Supplier"
                                                helperText={errors.supplier_id?.message as string}
                                                error={!!errors.supplier_id}
                                            />
                                        )}
                                    />
                                )}
                            />
                        </Grid>
                        {/* Invoice Receipt */}
                        <Grid item xs={12}>
                            <Controller
                                name="accir_id"
                                control={control}
                                rules={{ required: "Invoice Receipt wajib dipilih" }}
                                render={({ field }) => (
                                    <Autocomplete
                                        {...field}
                                        value={field.value || null}
                                        options={invoiceReceiptList}
                                        isOptionEqualToValue={(opt, val) => opt.id === val?.id}
                                        getOptionLabel={(o) => o?.id ? o?.id + " | " + o?.nomor_nota + " | " + formatNumber(o?.total) + " | " + o?.tgl : ""}
                                        onChange={(_, val) => {
                                            field.onChange(val)
                                            setValue('totalInvoice', val?.total)
                                            setValue('sisaHutang', val?.total)
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Invoice"
                                                helperText={errors.accir_id?.message as string}
                                                error={!!errors.accir_id}
                                            />
                                        )}
                                    />
                                )}
                            />
                        </Grid>

                        {/* Tanggal */}
                        <Grid item xs={12}>
                            <Controller
                                name="tanggal"
                                control={control}
                                rules={{ required: "Tanggal wajib diisi" }}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        type="date"
                                        label="Tanggal Memo"
                                        InputLabelProps={{ shrink: true }}
                                        helperText={errors.tanggal?.message as string}
                                        error={!!errors.tanggal}
                                        fullWidth
                                    />
                                )}
                            />
                        </Grid>
                        {/* INFORMASI TAGIHAN */}
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                Informasi Tagihan
                            </Typography>
                        </Grid>

                        {/* Total Invoice */}
                        <Grid item xs={12}>
                            <Controller
                                name="totalInvoice"
                                control={control}
                                rules={{ required: "Total invoice wajib diisi" }}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        label="Total Invoice"
                                        fullWidth
                                        value={formatNumber(field.value || "0")}
                                        inputProps={{ inputMode: "numeric", readOnly: true }}
                                        onChange={(e) => field.onChange(formatNumber(e.target.value))}
                                        error={!!errors.totalInvoice}
                                        helperText={errors.totalInvoice?.message as string}
                                    />
                                )}
                            />
                        </Grid>

                        {/* Sisa Hutang */}
                        <Grid item xs={12}>
                            <Controller
                                name="sisaHutang"
                                control={control}
                                rules={{ required: "Sisa hutang wajib diisi" }}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        label="Sisa Hutang Saat Ini"
                                        fullWidth
                                        value={formatNumber(field.value || "0")}
                                        inputProps={{ inputMode: "numeric", readOnly: true }}
                                        onChange={(e) => field.onChange(formatNumber(e.target.value))}
                                        error={!!errors.sisaHutang}
                                        helperText={errors.sisaHutang?.message as string}
                                    />
                                )}
                            />
                        </Grid>

                        {/* PENYESUAIAN */}
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                Penyesuaian
                            </Typography>
                        </Grid>

                        {/* Akun */}
                        <Grid item xs={12}>
                            <Controller
                                name="akun"
                                control={control}
                                rules={{ required: "Akun penyesuaian wajib dipilih" }}
                                render={({ field }) => (
                                    <Autocomplete
                                        {...field}
                                        value={field.value || null}
                                        options={akunList}
                                        isOptionEqualToValue={(opt, val) => opt.id === val?.id}
                                        getOptionLabel={(o) => o?.nama ?? ""}
                                        onChange={(_, val) => field.onChange(val)}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Akun Penyesuaian"
                                                helperText={errors.akun?.message as string}
                                                error={!!errors.akun}
                                            />
                                        )}
                                    />
                                )}
                            />
                        </Grid>

                        {/* Total Sesuaian */}
                        <Grid item xs={12}>
                            <Controller
                                name="totalSesuaian"
                                control={control}
                                rules={{ required: "Total penyesuaian wajib diisi" }}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        label="Total Penyesuaian"
                                        fullWidth
                                        value={formatNumber(field.value || "0")}
                                        inputProps={{ inputMode: "numeric" }}
                                        onChange={(e) => {
                                            const raw = e.target.value.replace(/\D/g, "") // hanya angka
                                            field.onChange(raw)
                                        }}
                                        error={!!errors.totalSesuaian}
                                        helperText={errors.totalSesuaian?.message as string}
                                    />
                                )}
                            />
                        </Grid>

                        {/* HASIL */}
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                Hasil Akhir
                            </Typography>
                        </Grid>

                        {/* Hutang Akhir */}
                        <Grid item xs={12}>
                            <Controller
                                name="hutangAkhir"
                                control={control}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        label="Hutang Setelah Penyesuaian"
                                        fullWidth
                                        InputProps={{
                                            readOnly: true
                                        }}
                                    />
                                )}
                            />
                        </Grid>

                        {/* CATATAN */}
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                Catatan
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Controller
                                name="keterangan"
                                control={control}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        label="Keterangan"
                                        multiline
                                        rows={3}
                                        fullWidth
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        size="large"
                    >
                        SIMPAN MEMO AP
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    )
}